import {Injectable} from '@angular/core';
import {ApplicantView, Application, Log} from 'src/app/shared/models/models';
import {
  AdminApplicationControllerService,
  ApplicantAccountControllerService,
  ApplicantControllerService,
  ApplicantIdentityResponseRequest,
  ApplicantRequest,
  ApplicationDetailLog,
  ApplicationLog,
  ApplicationLogDetailsRequest,
  ApplicationLogsControllerService,
  ApplicationLogsFilterRequest,
  ApplicationLogsRequest,
  ApplicationLogStepRequest,
  ApplicationLogsUpdateRequest,
  Page,
  SecureApplicationControllerService,
  SecureApplicationCreateResponse,
  ApplicantAddress,
  Step,
  ResumeApplicationRequest
} from "leia-api";
import {NGXLogger} from "ngx-logger";
import {HttpClient} from "@angular/common/http";
import {getEmptyStringIfNull, UtilitiesService, ValidArray} from "../core/services/utilities.service";
import {environment} from "../../environments/environment";
import {
  AccountHolders,
  Accounts,
  Addresses,
  AddressVerificationControllerService,
  AddressVerificationRequest,
  AddressVerificationResponse, AlloyEntityEvaluationResponse,
  Applicants,
  CaliperApiControllerService,
  CustomerControllerService,
  EligibilityResponse,
  EnrollmentControllerService,
  EnrollmentRequest,
  EvaluateRequest,
  GetCustomerRequest,
  KycControllerService,
  PhoneNumbers,
  Product,
  RelationshipManagers,
  ServiceResponse
} from "skyhopper-api";
import {RelationshipCode} from "../shared/models/relationship-code";
import {
  ADDRESS_TYPE_PRIMARY, APPLICATION_LOG_REQUEST_SESSION_KEY, ELIGIBILITY_FAILURE, EMPLOYEE_SAVINGS_PRODUCT_UID,
  OKTA_TOKEN_STORAGE_KEY, ONBOARDING_REQUEST_SESSION_KEY,
  PERSONAL,
  PHONETYPE_MOBILE,
  PRIMARY_APPLICANT_LABEL,
  SECONDARY_APPLICANT_LABEL,
  TAXID_FLAG
} from "../shared/constants";
import {CustomerInfo} from "../shared/models/customer-info";
import {LoadingDialogService} from "../shared/services/loading-dialog.service";
import {SessionStorageService} from "../shared/models/session-storage.service";
import {OnboardingRequest} from "../shared/models/onboarding-request.model";
import {
  BehaviorSubject,
  first, firstValueFrom,
  lastValueFrom,
  Observable,
  of,
  throwError
} from "rxjs";
import {SocureStatus} from "../shared/models/socure-status";
import {FacadeService} from "../shared/services/facade.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import * as moment from "moment";
import {FeatureFlags, Features} from '../core/services/feature-flags.service';
import {AuditLoggerControllerService} from 'falcon-api';
import {AuthService} from '../core/auth/auth.service';
import {AlloyMode} from "../shared/models/alloy-mode";
import {AlloyOutcome} from "../shared/models/alloy-outcome";
import {AlloyResult} from "../shared/models/alloy-result";
import {State} from "../shared/models/state";
import {ReferenceCode} from "../shared/models/reference-code";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {EnrollmentTypeEnum} from '../shared/models/enrollment-type.enum';
import {BrandEnum} from "../shared/models/brand.enum";
import StatusEnum = ApplicationLogsRequest.StatusEnum;
import NameEnum = Step.NameEnum;
import StateEnum = Step.StateEnum;
import OnboardingSourceEnum = ApplicationLogStepRequest.OnboardingSourceEnum;
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;
import ServiceTypeEnum = ApplicantIdentityResponseRequest.ServiceTypeEnum;
import {ServiceType} from "../shared/models/service-type";
import {
  catchError,
  map
} from "rxjs/operators";
import {AddressType} from "../shared/models/address-type.enum";
import {EnrollmentResponse} from "skyhopper-api/model/enrollmentResponse";

const jsonExport = require("jsonexport/dist");
const fileSaver = require("file-saver");

interface EligibilityCriteriaResult {
  eligible: boolean;
  log: Log;
}

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  logs?: Array<Log> = [];
  applicants: Array<ApplicantView> = [];
  applicantIdentityResponseIdMap: Map<number, number> = new Map<number, number>();
  id: string = '';
  bsaProfileComplete = false;
  public onboardingRequest$: BehaviorSubject<OnboardingRequest> = new BehaviorSubject(new OnboardingRequest());
  private applications: Array<Application> = [];
  private applicationLog?: Application;
  isFilterApplied: boolean = false;
  appliedFilterData: any;
  tempStateList: State[] = []
  applicationDashboardTabSelectedIndex: number = 0;

  // filterConfiguration, values > 1 will turn off the new filters, 1 and 0 turn them on
  filterConfiguration: number = 0;

  private processing: BehaviorSubject<boolean>;
  private applicationLoading: BehaviorSubject<boolean>;

  /**
   * Constructor
   * @param applicantService Application service instance.
   * @param adminApplicationService
   * @param logger Logger instance.
   * @param http
   * @param utils
   * @param secureApplicationService
   * @param leiaService
   * @param enrollmentService
   * @param customerService
   * @param loadingDialog
   * @param caliperApiControllerService
   * @param sessionStorageService
   * @param skyhopperService
   * @param leiaApplicantService
   * @param facadeService
   * @param snackBar
   */
  constructor(private applicantService: ApplicationLogsControllerService,
              private adminApplicationService: AdminApplicationControllerService,
              private logger: NGXLogger,
              private http: HttpClient,
              private utils: UtilitiesService,
              private authService: AuthService,
              private auditLogController: AuditLoggerControllerService,
              private secureApplicationService: SecureApplicationControllerService,
              private leiaService: ApplicationLogsControllerService,
              private enrollmentService: EnrollmentControllerService,
              private customerService: CustomerControllerService,
              private loadingDialog: LoadingDialogService,
              private caliperApiControllerService: CaliperApiControllerService,
              private sessionStorageService: SessionStorageService,
              private skyhopperService: AddressVerificationControllerService,
              private kycService: KycControllerService,
              private leiaApplicantService: ApplicantControllerService,
              private facadeService: FacadeService,
              private snackBar: MatSnackBar,
              private featureFlags: FeatureFlags,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private customerControllerService: CustomerControllerService,
              private applicantControllerService: ApplicantControllerService,
              private kycControllerService: KycControllerService,
              private applicantAccountControllerService: ApplicantAccountControllerService,
  ) {
    this.getStateList();
    this.processing = new BehaviorSubject<boolean>(false);
    this.applicationLoading = new BehaviorSubject<boolean>(true);
  }

  getProcessingStatus(): Observable<boolean> {
    return this.processing.asObservable();
  }

  setProcessingStatus(value: boolean) {
    this.processing.next(value);
  }

  getApplicationLoadingStatus(): Observable<boolean> {
    return this.applicationLoading.asObservable();
  }

  setApplicationLoadingStatus(value: boolean) {
    this.applicationLoading.next(value);
  }

  //get sessionId
  get sessionId(): string {
    return this.id;
  }

  set sessionId(sessionId: string) {
    this.id = sessionId;
  }

  //get sessionId
  get bsaProfileStatus(): boolean {
    return this.bsaProfileComplete;
  }

  set bsaProfileStatus(status: boolean) {
    this.bsaProfileComplete = status;
  }

  //Get applicationLogRequest Object from session or create new object
  get applicationLogsRequest(): ApplicationLogsRequest {
    let applicationLog = this.sessionStorageService.get(APPLICATION_LOG_REQUEST_SESSION_KEY);
    if (!applicationLog) {
      applicationLog = new ApplicationLogsRequest();
      this.applicationLogsRequest = applicationLog;
    }
    return applicationLog;
  }

  //set the applicationLogRequest to session
  set applicationLogsRequest(request: ApplicationLogsRequest) {
    this.sessionStorageService.set(APPLICATION_LOG_REQUEST_SESSION_KEY, request);
  }

  //Get OnboardingRequest Object from session or create new object
  get onboardingRequest(): OnboardingRequest {
    let onboarding = this.sessionStorageService.get(ONBOARDING_REQUEST_SESSION_KEY);
    if (!onboarding) {
      onboarding = new OnboardingRequest();
      this.onboardingRequest = onboarding;
    }
    return onboarding;
  }

  //set the OnboardingRequest to session
  set onboardingRequest(request: OnboardingRequest) {
    this.sessionStorageService.set(ONBOARDING_REQUEST_SESSION_KEY, request);
  }

  /**
   * Create a new session in the leia service and set the session ID.
   */
  submitApplication(brandId: number, successCallback: (sessionId: string, message: string, uniqueLink: string, uniqueCode: string) => void, errorCallback: () => void) {
    const applicationLogRequest = this.applicationLogsRequest;
    const logs: Log[] = [];
    const applicationLogDetailsRequests: ApplicationLogDetailsRequest[] = [];
    const applicationProduct = applicationLogRequest.products?.find(product => !!product);
    //STEP 1 - Create Application
    logs.push(this.utils.createLog("Coruscant", "Application submitted internally by User:" + this.getPreferredUsername())); // TODO: replace User with employee name after Okta integration
    logs.push(this.utils.createLog("Coruscant", "Selected Product - " + applicationProduct?.productDescription));
    let step = this.utils.createStep(NameEnum.ProductSelection, StateEnum.Success, logs);

    applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Application submitted internally by User:" + this.getPreferredUsername()));
    applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Selected Product - " + applicationProduct?.productDescription));

    let applicationLogStepRequest = this.utils.createApplicationLogStepRequest(OnboardingStepEnum.PRODUCTIONSELECTION, OnboardingStateEnum.SUCCESS, OnboardingSourceEnum.CORUSCANT, applicationLogDetailsRequests);

    applicationLogRequest.step = step;
    applicationLogRequest.applicationLogStepRequest = applicationLogStepRequest;

    this.leiaService.startSession(applicationLogRequest).subscribe((response: any) => {
      let sessionId = response.toString();
      applicationLogRequest.sessionId = sessionId;
      this.sessionId = sessionId;
      this.applicationLogsRequest = applicationLogRequest;
      let message = "Application Created";
      //STEP 2 - Generate Link+Code
      this.generateUniqueLinkAndCode(this.sessionId, brandId, successCallback, message);
      this.applicationLogsRequest = applicationLogRequest;
    }, (error: any) => {
      this.logger.error("Failed to submit application - " + error);
      //TODO: Handle this error by redirecting to failure page
      errorCallback();
    });
    //});
  }

  /**
   * Get list of applications from service.
   */
  public getApplications(size?: number, page?: number): Observable<Page> {
    return this.adminApplicationService.getApplicationLogs(size, page);
  }

  /**
   * Get application
   * @param sessionId Session ID to lookup application.
   */
  async getApplication(sessionId: string): Promise<ApplicationDetailLog> {
    const applicationLog$ = this.applicantService.getApplicationLog(sessionId);
    const applicationLog = await lastValueFrom(applicationLog$);

    return applicationLog;
  }

  search(filter: string, size?: number, page?: number, sort?: string, sortDirection?: string): Observable<Page> {
    let filterRequest = new ApplicationLogsFilterRequest();
    filterRequest.filter = filter;

    if (filter && this.isFilterApplied) {
      const queryParams: Params = {filter: filter, appliedFilterData: JSON.stringify(this.appliedFilterData)};
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: queryParams,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        });
    } else {
      const qParams: Params = {filter: null};
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: qParams,
        queryParamsHandling: 'merge'
      });
    }


    return this.adminApplicationService.search(filterRequest, sort, sortDirection, size, page);
  }

  download(filter: string, includeLogs: boolean) {
    this.export(filter).subscribe(applications => {

      if (!includeLogs) {
        for (let application of applications) {
          application.steps = [];
        }
      }

      jsonExport(applications, (err: any, csv: any) => {
        if (err) return console.error(err); // TODO: show message here
        let date = new Date();
        let fileName = `${moment(date).format('YYYYMMDD_HHmmss')}_applications${filter !== "" ? "_filtered" : ""}.csv`
        let blob = new Blob([csv], {type: 'text/csv'})
        fileSaver.saveAs(blob, fileName);
      });
    });
  }

  export(filter: string): Observable<Array<ApplicationLog>> {
    let filterRequest = new ApplicationLogsFilterRequest();

    filterRequest.filter = filter;

    return this.adminApplicationService._export(filterRequest);
  }

  /**
   * Method to generate Unique Link & code.
   * @param sessionId
   * @param successCallback
   * @param message
   */
  generateUniqueLinkAndCode(sessionId: any, brandId: number, successCallback: (sessionId: string, message: string, uniqueLink: string, uniqueCode: string) => void, message: string) {
    this.secureApplicationService.generateSecureAttributes(sessionId).subscribe((response: SecureApplicationCreateResponse) => {
      let {secureSessionCode, secureSessionId} = response;
      const baseURL = brandId === BrandEnum.BaskBank ? environment.client_bask_base_url_bb8 : environment.client_base_url_bb8;

      successCallback(sessionId, message, `${baseURL}verify/${secureSessionId}`, secureSessionCode!);
    }, (error: any) => {
      message = "Unique Link & Code Generation failed.";
      this.logger.error("Failed to create secured onetime code - " + error);
    });
  }

  /**
   * Method to generate Unique Link & code.
   * @param resumeApplicationRequest
   * @param brandId
   * @param successCallback
   *
   */
  async resumeApplication(resumeApplicationRequest: ResumeApplicationRequest, brandId: number, successCallback: (sessionId: string, uniqueLink: string, uniqueCode: string) => void) {
    await this.secureApplicationService.resumeApplication(resumeApplicationRequest).toPromise();
    const sessionId = resumeApplicationRequest.sessionId!;
    const baseURL = brandId === BrandEnum.BaskBank ? environment.client_bask_base_url_bb8 : environment.client_base_url_bb8;

    this.getApplicationSecureDetails(sessionId).subscribe(secureApplicationCreateResponse => {
      successCallback(sessionId, `${baseURL}verify/${secureApplicationCreateResponse.secureSessionId}`, secureApplicationCreateResponse.secureSessionCode!);
    });
  }

  /**
   * Method to generate secret code.
   * @param secureSessionId
   * @param successCallback
   */
  generateSecretCode(secureSessionId: any, successCallback: () => void, errorCallback: (message: string) => void) {
    this.secureApplicationService.generateUniqueCode(secureSessionId).subscribe((response: any) => {
      successCallback();
    }, (error: any) => {
      this.logger.error("Failed to create secured onetime code - " + error);
      errorCallback("Unique Code Generation failed.");
    });
  }

  //get secure code & session Id
  getApplicationSecureDetails(sessionId: string): Observable<SecureApplicationCreateResponse> {
    return this.secureApplicationService.getApplicationSecureDetails(sessionId);
  }

  /**
   * Update application logs request to the leia service.
   */
  updateApplication(name: NameEnum, stepEnum: OnboardingStepEnum, state: Step.StateEnum, stateEnum: OnboardingStateEnum, logs: Log[], logDetails: ApplicationLogDetailsRequest[], applicationRequest: ApplicationLogsRequest): Promise<any> {
    let step = this.utils.createStep(name, state, logs);
    let applicationLogStepRequest = this.utils.createApplicationLogStepRequest(stepEnum, stateEnum, OnboardingSourceEnum.CORUSCANT, logDetails);

    if (applicationRequest.rcCode !== undefined) applicationLogStepRequest.rcCode = applicationRequest.rcCode;

    applicationRequest.step = step;
    applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

    if (environment.development)
      this.logger.log("updateApplication:" + JSON.stringify(applicationRequest));

    return this.updateApplicationLogs(applicationRequest);
  }

  updateApplicationLogs(applicationRequest: ApplicationLogsRequest): Promise<any> {
    return this.leiaService.update(applicationRequest).toPromise().catch(error => {
      if (environment.development)
        this.logger.log("Failed to update application log to leia service - " + error);
    });
  }

  addUserInitiatedLog(message: string, sessionId: string) {
    const applicationLogsUpdateRequest = new ApplicationLogsUpdateRequest();
    applicationLogsUpdateRequest.sessionId = sessionId;
    const logDetails: ApplicationLogDetailsRequest[] = [];

    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, `User: ${this.getPreferredUsername()}, ${message}`));

    applicationLogsUpdateRequest.logDetailsRequest = logDetails;

    this.updateLogs(applicationLogsUpdateRequest);
  }

  addLog(message: string, sessionId: string) {
    const applicationLogsUpdateRequest = new ApplicationLogsUpdateRequest();
    applicationLogsUpdateRequest.sessionId = sessionId;
    const logDetails: ApplicationLogDetailsRequest[] = [];

    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, message));

    applicationLogsUpdateRequest.logDetailsRequest = logDetails;

    this.updateLogs(applicationLogsUpdateRequest);
  }


  updateLogs(applicationLogsUpdateRequest: ApplicationLogsUpdateRequest): Promise<any> {
    return this.leiaService.updateAppLogs(applicationLogsUpdateRequest).toPromise().catch(error => {
      if (!environment.production)
        this.logger.log("Failed to update application log to leia service - " + error);
    });
  }

  updateApplicationWithObservable(name: NameEnum, stepEnum: OnboardingStepEnum, state: Step.StateEnum, stateEnum: OnboardingStateEnum, logs: Log[], logDetails: ApplicationLogDetailsRequest[], applicantId: number | undefined, rcCode: string | undefined, applicationRequest: ApplicationLogsRequest): Observable<any> {
    let step = this.utils.createStep(name, state, logs);
    let applicationLogStepRequest = this.utils.createEntireApplicationLogStepRequest(stepEnum, stateEnum, OnboardingSourceEnum.CORUSCANT, applicantId!, rcCode, logDetails);

    applicationRequest.step = step;
    applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

    if (environment.development)
      this.logger.log("updateApplication:" + JSON.stringify(applicationRequest));
    return this.updateApplicationLogsWithObservable(applicationRequest);
  }

  updateApplicationLogsWithObservable(applicationRequest: ApplicationLogsRequest): Observable<any> {
    return this.leiaService.update(applicationRequest).pipe(catchError((err, caught) => {
      this.onError("Application Update Failed. Please refresh your web browser to try again.");
      return throwError(err);
    }));
  }

  /**
   * Form enrollment request and make signature enrollment service call.
   * @param application
   * @param product
   * @param successCallback
   * @param errorCallback
   */
  async resubmitApplication(application: Application, isJoint: boolean, product: Product, olbGroupId: number, brandName: string | undefined, eligibilityResponse: EligibilityResponse, successCallback: () => void, errorCallback: (message: string) => void) {
    this.auditLogController.log({
      action: "Push to core.",
      userName: this.authService.userClaims?.preferred_username,
      methodPath: "application.service.resubmitApplication",
      arguments: JSON.stringify({
        application: JSON.stringify(application),
        product: JSON.stringify(product),
        olbGroupId,
        brandName
      })
    }).subscribe();

    this.addUserInitiatedLog("Beginning applicant enrollment to Signature.", application.sessionId!);

    const applicationRequest = this.applicationLogsRequest;
    const applicationProduct = this.applicationLogsRequest!.products?.find(product => !!product);
    if (!!applicationProduct?.interestPlanCode) product.interestPlanCode = applicationProduct?.interestPlanCode!.toString();

    const {sessionId} = application;
    applicationRequest.sessionId = sessionId!;
    applicationRequest.products = application.products;
    const enrollmentRequest = new EnrollmentRequest();
    enrollmentRequest.sessionId = application.sessionId!;
    enrollmentRequest.accounts = this.getAccounts(application, product)!;
    enrollmentRequest.brandName = brandName;
    enrollmentRequest.applicants = this.getApplicants(application, errorCallback, applicationRequest, olbGroupId, eligibilityResponse);
    enrollmentRequest.isApplicationResubmission = true; //always true for resubmission

    if (isJoint) {
      enrollmentRequest.requestType = EnrollmentTypeEnum.JointApplicationMaintenance;
    }

    //ApplicantList will be empty if the customer check failed.
    if (enrollmentRequest.applicants.length > 0) {
      this.enrollmentCall(enrollmentRequest, applicationRequest, successCallback, errorCallback);
    }
  }

  /**
   * Make Signature Enrollment service call.
   * on success, reload page
   * failure, show error message in the popup.
   * @param enrollmentRequest
   * @param applicationRequest
   * @param successCallback
   * @param errorCallback
   */
  enrollmentCall(enrollmentRequest: EnrollmentRequest, applicationRequest: ApplicationLogsRequest, successCallback: () => void, errorCallback: (message: string) => void) {
    const logs: Log[] = [];
    const logDetails: ApplicationLogDetailsRequest[] = [];

    let details = "";
    this.enrollmentService.enrollMultiProduct("", enrollmentRequest.sessionId).subscribe(async (enrollmentResponse: EnrollmentResponse) => {
      if (enrollmentResponse.status !== "Approved" || enrollmentResponse.rcCode) {
        details = "Resubmit - Enrollment Complete but Account details are not returned from the API";

        this.addLog(details, applicationRequest.sessionId);
        this.facadeService.refreshPage();
        errorCallback(details);
      } else {
        successCallback();
      }
    }, async (error: any) => {
      logs.push(this.utils.createLog("SKH", JSON.stringify(error)));
      logs.push(this.utils.createLog("Coruscant", "Resubmit - Enrollment call failed."));

      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.SKYHOPPER, JSON.stringify(error)));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Resubmit - Enrollment call failed."));

      await this.updateApplication(NameEnum.SignatureEnrollment, OnboardingStepEnum.SIGNATUREENROLLMENT, StateEnum.Fail, OnboardingStateEnum.FAIL, logs, logDetails, applicationRequest);
      errorCallback("Resubmit - Enrollment call failed.");
    });
  }

  /**
   * Customer existing check call. In order to make a synchronous call, Promise - async/await implementation.
   * @param ssn
   * @param isPrimary
   */
  existingCustomerCheck(ssn: string, isPrimary: boolean, applicationRequest: ApplicationLogsRequest): Promise<CustomerInfo> {
    const customerRequest = new GetCustomerRequest();
    customerRequest.ssn = ssn.replace(/-/gi, "");
    const logs: Log[] = [];
    const logDetails: ApplicationLogDetailsRequest[] = [];

    applicationRequest.status = "Under Review";
    let customerInfo: CustomerInfo = {
      checkSucceeded: false
    };
    return new Promise(resolve => {
      this.customerService.getCustomerInfo(customerRequest).subscribe(response => {
        logs.push(this.utils.createLog("SKH", JSON.stringify(response)));
        logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.SKYHOPPER, JSON.stringify(response)));

        this.updateCustomerInfo(response, customerRequest.ssn!, isPrimary, customerInfo, logs, logDetails, applicationRequest);
        resolve(customerInfo);
      }, error => {
        logs.push(this.utils.createLog("SKH", JSON.stringify(error)));
        logs.push(this.utils.createLog("Coruscant", "Resubmit - Unable to perform Existing customer check call failed."));

        logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.SKYHOPPER, JSON.stringify(error)));
        logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Resubmit - Unable to perform Existing customer check call failed."));

        this.updateApplication(NameEnum.ExistingCustomerCheck, OnboardingStepEnum.EXISTINGCUSTOMERCHECK, StateEnum.Fail, OnboardingStateEnum.FAIL, logs, logDetails, applicationRequest);
        resolve(customerInfo);
      });
    });
  }

  /**
   * To get the list of applicant details.
   * set applicant details to the Applicant Object.
   * @param application
   * @param errorCallback
   * @param applicationRequest
   */
  getApplicants(application: Application, errorCallback: (message: string) => void, applicationRequest: ApplicationLogsRequest, olbGroupId: number, eligibilityResponse: EligibilityResponse) {
    let applicantsList: Array<Applicants> = [];
    for (const applicant of application.applicants!) {
      const {
        firstName, middleName, lastName, suffix, email, dateOfBirth, ssn, primary, phoneNumber, isKyc, userName,
        applicantId, cif
      } = applicant;
      const {
        state, city,
        streetAddress1, streetAddress, zip
      } = applicant.addresses?.find(physicalAddress => physicalAddress.addressType === AddressType.Physical)!;
      let applicants = new Applicants();
      let contactList: Array<PhoneNumbers> = [];
      let addressList: Array<Addresses> = [];
      let phoneNumbers = new PhoneNumbers();

      //Set contact details
      phoneNumbers.number = phoneNumber!;
      phoneNumbers.type = PHONETYPE_MOBILE;
      contactList.push(phoneNumbers);

      //Set Address details
      let address = new Addresses();
      address.state = state!.substring(0, 2);
      address.city = city;
      address.country = "US"; // Check
      address.street = streetAddress!.split(/ (.+)/)[1];
      address.houseNumber = streetAddress!.split(/ (.+)/)[0];
      address.zipCode = zip!;
      address.type = ADDRESS_TYPE_PRIMARY;

      // Bug 396867: send address line 2 in enrollment request
      address.address2 = streetAddress1;

      addressList.push(address);

      //Set Customer Info
      const customerEligibilityResult = new ValidArray(eligibilityResponse.applicants!.filter(record => record.applicantId === applicantId));

      //If existing customer check call failed.
      if (!customerEligibilityResult.hasValues()) {
        errorCallback("Customer Check Call Failed - System/Internal Error.");
        break;
      }

      const customerEligibility = customerEligibilityResult.first();
      const {isInGoodStanding, isEnrolledInOLB, isExisting, hasInfoMismatch} = customerEligibility!;

      //If applicant info Mismatch, return error message.
      if (hasInfoMismatch) {
        let message = `Customer Eligibility Check Failed for user  - ${firstName} ${lastName}, Applicant Info Mismatch.`;
        errorCallback(message);
        break;
      }

      //If customer is not in good standing.
      if (!isInGoodStanding) {
        let message = `Customer Eligibility Check Failed for user  - ${firstName} ${lastName}`;
        errorCallback(message);
        break;
      }

      applicants.isExistingCustomer = isExisting!;
      applicants.isEnrolledInOlb = isEnrolledInOLB!;
      applicants.requiresKyc = isKyc!;
      applicants.firstName = firstName!;
      applicants.middleName = middleName!;
      applicants.lastName = lastName!;
      applicants.nameSuffix = suffix;
      applicants.emailAddress = email!;
      applicants.shortName = `${applicants.lastName} ${applicants.firstName}`.toUpperCase().substring(0, 17);//check
      applicants.birthDate = dateOfBirth!;
      applicants.taxIdNumber = ssn!.replace(/-/g, '');
      applicants.taxIdFlag = TAXID_FLAG;
      applicants.customerType = PERSONAL;
      applicants.isPrimary = primary!;
      applicants.userName = userName;
      applicants.groupId = olbGroupId;
      applicants.requiresPasswordReset = false;
      applicants.applicantId = applicantId!;
      applicants.cif = cif;

      applicants.phoneNumbers = contactList;

      applicants.addresses = addressList;
      applicantsList.push(applicants);
    }
    return applicantsList;
  }

  pushShoppingCartOnboardingRequest(onboardingRequest: OnboardingRequest): void {
    this.onboardingRequest$.next(onboardingRequest);
  }

  _updateApplication(applicationLogsRequest: ApplicationLogsRequest, onboardingRequest: OnboardingRequest): void {
    this.onboardingRequest = onboardingRequest;
    this.applicationLogsRequest = applicationLogsRequest;
    applicationLogsRequest.sessionId = this.id;
    if (environment.development)
      this.logger.log("updateApplication:" + JSON.stringify(applicationLogsRequest));
  }

  clearStorage(): void {
    this.sessionStorageService.clear();
  }

  /**
   * Method to set the existing customer check response to customerinfo object.
   * @param response
   * @param updateApplicationLog
   * @param isPrimary
   * @param customerInfo
   * @param logs
   * @param applicationRequest
   * @private
   */
  private updateCustomerInfo(response: ServiceResponse, ssn: string, isPrimary: boolean, customerInfo: CustomerInfo, logs: Log[], logDetails: ApplicationLogDetailsRequest[], applicationRequest: ApplicationLogsRequest) {
    let details = "";
    const last4 = ssn.substring(5);
    if (!response.responseContent || !response.responseContent.isExisting) {
      details = `Customer with SSN XXX-XX-${last4} not found.`;
    } else {
      details = `${isPrimary ? "Primary" : "Co-applicant"} - Customer with SSN XXX-XX-${last4} found.`;
    }
    customerInfo.checkSucceeded = true;
    customerInfo.isExistingCustomer = response.responseContent.isExisting;
    customerInfo.isEnrolledInOLB = response.responseContent.isEnrolledInOLB;
    customerInfo.isInGoodStanding = response.responseContent.isInGoodStanding;

    logs.push(this.utils.createLog("Coruscant", details));
    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, details));

    this.updateApplication(NameEnum.ExistingCustomerCheck, OnboardingStepEnum.EXISTINGCUSTOMERCHECK, StateEnum.Success, OnboardingStateEnum.SUCCESS, logs, logDetails, applicationRequest);
  }

  getJointAccountInfoBySessionId(sessionId: string): Observable<any> {
    return this.applicantAccountControllerService.getAccountProductDetailsBySessionId(sessionId)
  }

  /**
   * Method to get the account details.
   * @param application
   * @param product
   * @private
   */
  private getAccounts(application: Application, product: Product) {
    let accountsList: Array<Accounts> = [];
    let relationshipManagersList: Array<RelationshipManagers> = [];
    let accountHoldersList: Array<AccountHolders> = [];
    let accounts = new Accounts();
    accounts.branchCode = "23";
    accounts.product = product;

    //Set RelationshipManager details
    let relationshipManagers = new RelationshipManagers();
    relationshipManagers.role = "officer";
    relationshipManagers.officerCode = "CON";
    relationshipManagersList.push(relationshipManagers);
    accounts.relationshipManagers = relationshipManagersList;

    //Set AccountHolder details
    application.applicants?.forEach(applicant => {
      let accountHolder = new AccountHolders();
      accountHolder.taxIdNumber = applicant.ssn!.replace(/-/g, '');
      accountHolder.relationCode = this.getRelationCode(applicant, application.applicants!.length > 1, this.getIsMinor(product.productCode));
      accountHolder.taxLiability = applicant.primary ? 100 : 0;
      accountHoldersList.push(accountHolder);
      accounts.accountHolders = accountHoldersList;
    });
    accountsList.push(accounts);
    return accountsList;
  }

  /**
   * Set relationship code based on the applicant type.
   * @param applicant
   * @param isJoint
   * @private
   */
  private getRelationCode(applicant: ApplicantRequest, isJoint: boolean, isMinor: boolean): string {
    // for single applicant, always sole owner
    if (!isJoint) return RelationshipCode.SoleOwner;

    // for joint, primary is JOF and secondary is JOO
    if (!isMinor) return applicant.primary ? RelationshipCode.JointOrFirst : RelationshipCode.JointOrOther;
    else return applicant.primary ? RelationshipCode.Owner : RelationshipCode.Custodian;
  }

  // /**
  //  * This method is to prepare the push to Q2 request and call the skyhopper request to push the application in Q2
  //  * @param application
  //  * @param product
  //  * @param successCallback
  //  * @param errorCallback
  //  */
  // async pushApplicationToQ2(application: Application, product: Product, olbGroupId: number, brandName: string | undefined, successCallback: () => void, errorCallback: (message: string) => void) {
  //   this.auditLogController.log({
  //     action: "Push to Q2.",
  //     userName: this.authService.userClaims?.preferred_username,
  //     methodPath: "application.service.pushApplicationToQ2.",
  //     arguments: JSON.stringify({
  //       application: JSON.stringify(application),
  //       product: JSON.stringify(product),
  //       olbGroupId,
  //       brandName
  //     })
  //   }).subscribe();
  //   const applicationRequest = this.applicationLogsRequest;
  //   this.updateUserInitiatedEventDetails("Push to Q2 Initiated.");
  //   const {sessionId, productCode, productDescription} = application;
  //
  //   applicationRequest.sessionId = sessionId!;
  //   applicationRequest.productCode = productCode;
  //   applicationRequest.productDescription = productDescription;
  //   //Push to Q2
  //   const caliperQ2EnrollRequest = new CaliperQ2EnrollRequest();
  //   caliperQ2EnrollRequest.sessionId = sessionId;
  //   caliperQ2EnrollRequest.brandName = brandName;
  //   // This code needs to be refactored once push to Q2 is implemented
  //   //
  //   // caliperQ2EnrollRequest.applicants = await this.getApplicants(application, errorCallback, applicationRequest, olbGroupId);
  //   // ApplicantList will be empty if the customer check failed.
  //   // if (caliperQ2EnrollRequest.applicants.length > 0) {
  //     // this.pushToQ2Call(caliperQ2EnrollRequest, applicationRequest, successCallback, errorCallback);
  //   // }
  // }
  //
  // /**
  //  * Method to call skyhopper Q2 call to enroll the user in Q2
  //  * @param caliperQ2EnrollRequest
  //  * @param applicationRequest
  //  * @param successCallback
  //  * @param errorCallback
  //  */
  // pushToQ2Call(caliperQ2EnrollRequest: CaliperQ2EnrollRequest, applicationRequest: ApplicationLogsRequest, successCallback: () => void, errorCallback: (message: string) => void) {
  //   const logs: Log[] = [];
  //   const logDetails: ApplicationLogDetailsRequest[] = [];
  //
  //   this.caliperApiControllerService.enrollQ2User(caliperQ2EnrollRequest).subscribe(response => {
  //     console.log("After this.caliperApiControllerService.enrollQ2User call");
  //     logs.push(this.utils.createLog("SKH", JSON.stringify(response)));
  //     let details = "";
  //     //API returns either success or error. if the call is success, Q2 response status available in the response.
  //     if (!response || !(Array.isArray(response) && response.length)) {
  //       logs.push(this.utils.createLog("Coruscant", details));
  //       logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, details));
  //
  //       this.updateApplication(NameEnum.CaliperUserEnrollment, OnboardingStepEnum.CALIPERUSERENROLLMENT, StateEnum.Success, OnboardingStateEnum.SUCCESS, logs, logDetails, applicationRequest);
  //       errorCallback("Push To Q2 Request Completed with Failed status");
  //     }
  //
  //     let q2ResponseStatus = "Success";
  //     response.forEach(q2Resp => {
  //       details = `Push To Q2 Request Complete - ProductName - ${applicationRequest.productDescription}, Q2 Response Status - ${q2Resp.status}`;
  //       if (q2Resp.status === "Failed") {
  //         q2ResponseStatus = "Failed";
  //       }
  //     });
  //
  //     if (q2ResponseStatus === "Success") {
  //       logs.push(this.utils.createLog("Coruscant", details));
  //       logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, details));
  //
  //       applicationRequest.status = "Approved";
  //       this.updateApplication(NameEnum.CaliperUserEnrollment, OnboardingStepEnum.CALIPERUSERENROLLMENT, StateEnum.Success, OnboardingStateEnum.SUCCESS, logs, logDetails, applicationRequest);
  //       //Refresh the page on successful Q2 enrollment
  //       successCallback();
  //     } else {
  //       logs.push(this.utils.createLog("Coruscant", details));
  //       logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, details));
  //
  //       this.updateApplication(NameEnum.CaliperUserEnrollment, OnboardingStepEnum.CALIPERUSERENROLLMENT, StateEnum.Fail, OnboardingStateEnum.FAIL, logs, logDetails, applicationRequest);
  //       //Keep on the same page on Q2 enrollment error
  //       errorCallback("Push To Q2 Request Completed with Failed status");
  //     }
  //   }, error => {
  //     logs.push(this.utils.createLog("SKH", JSON.stringify(error)));
  //     logs.push(this.utils.createLog("Coruscant", "Push To Q2 call failed."));
  //     errorCallback("Push To Q2 call failed.");
  //     this.updateApplication(NameEnum.CaliperUserEnrollment, OnboardingStepEnum.CALIPERUSERENROLLMENT, StateEnum.Fail, OnboardingStateEnum.FAIL, logs, logDetails, applicationRequest);
  //   });
  // }

  /**
   * USPS Address Verify Service request to the skyhopper service.
   */
  addressVerify(addressVerifyRequest: AddressVerificationRequest): Observable<AddressVerificationResponse> {
    return this.skyhopperService.verifyAddress(addressVerifyRequest);
  }

  getPreferredUsername(): string {
    if (!!localStorage.getItem(OKTA_TOKEN_STORAGE_KEY) && localStorage.getItem(OKTA_TOKEN_STORAGE_KEY) !== "")
      return (JSON.parse(localStorage.getItem(OKTA_TOKEN_STORAGE_KEY)!).idToken.claims.preferred_username as string)
    return "";
  }

  onError = (message: string) => {
    this.setProcessingStatus(false);
    let snackbarRef = this.snackBar.open(message, "Dismiss", {
      duration: 5000,
    });

    snackbarRef.onAction().subscribe(() => {
      this.snackBar.dismiss();
    });
  }

  getIsMinor(productCode: string): boolean {
    if (productCode === '231') return true;

    return false;
  }

  getState(stateAbbrev: string | undefined): string {
    return this.tempStateList.find(state => state.stateAbbr === stateAbbrev)?.stateAbbr || "";
  }

  getStateList(): void {
    this.facadeService.loadAllStates().then((states) => {
      this.tempStateList = states;
    });
  }

  public getTaxId = (sessionId: string, applicantId: number): Observable<string> => this.adminApplicationService.getSsn(sessionId, applicantId);

  async verifyEligibility(onConfirmEligibilitySuccess: (eligibilityResponse: EligibilityResponse) => void, onConfirmEligibilityFailed: () => void) {
    this.addLog("Checking eligibility state for all applicants.", this.applicationLogsRequest.sessionId)

    try {
      const customerEligibilityResponse = await lastValueFrom(this.customerControllerService.getCustomerEligibility(this.applicationLogsRequest.sessionId));

      //TODO: Revisit this logic
      //application_log table updated with the applied promotional interest plan during eligibility call.
      //If employee savings product/user provided promotional code exist, get the applied promo code interest plan details from application_log table.
      // if (!!this.applicationLogsRequest.promoCodes || applicationProduct?.productUID === EMPLOYEE_SAVINGS_PRODUCT_UID) {
      //   await this.applicantService.getApplicationLog(this.applicationLogsRequest.sessionId!).toPromise().then(
      //     applicationResponse => {
      //       if (applicationResponse?.products!) {
      //         this.applicationLogsRequest.products = applicationResponse?.products;
      //       }
      //     });
      // }

      if (customerEligibilityResponse.rcCode) {
        onConfirmEligibilityFailed();
      } else {
        onConfirmEligibilitySuccess(customerEligibilityResponse);
      }

    } catch (error) {
      let logs: Log[] = [];
      let logDetails: ApplicationLogDetailsRequest[] = [];

      logs.push(this.utils.createLog(OnboardingSourceEnum.SKYHOPPER, JSON.stringify(error)));
      logs.push(this.utils.createLog(OnboardingSourceEnum.CORUSCANT, "User :" + this.getPreferredUsername().toUpperCase() + ", Confirm Eligibility call failed : " + error));

      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.SKYHOPPER, JSON.stringify(error)));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User :" + this.getPreferredUsername().toUpperCase() + ", Confirm Eligibility call failed : " + error));

      await lastValueFrom(this.updateApplicationWithObservable(NameEnum.EligibilityReview2, OnboardingStepEnum.ELIGIBILITYREVIEW2, StateEnum.Fail, OnboardingStateEnum.FAIL, logs.reverse(), logDetails.reverse(), undefined, ReferenceCode.GeneralFailure, this.applicationLogsRequest));

      onConfirmEligibilityFailed();
      this.onError("Confirm Eligibility call failed. Please check the logs.");
    }
  }

  reloadPage() {
    let currentUrl = this.router.url;
    const previousReuseRoute = this.router.routeReuseStrategy.shouldReuseRoute;
    const previousUrlNavigation = this.router.onSameUrlNavigation;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    //Reverting it back once reload complete - This fix the 'Back To Application' not redirecting to Application search page.
    setTimeout(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = previousReuseRoute;
      this.router.onSameUrlNavigation = previousUrlNavigation;
    }, 0);
  }

  updateUserInitiatedEventDetails(message: string) {
    const applicationRequest = this.applicationLogsRequest;
    const logs: Log[] = [];
    const logDetails: ApplicationLogDetailsRequest[] = [];

    logs.push(this.utils.createLog(OnboardingSourceEnum.CORUSCANT, `User: ${this.getPreferredUsername()}, ${message}`));
    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, `User: ${this.getPreferredUsername()}, ${message}`));

    let step = this.utils.createEmptyStepForLogging(logs);
    applicationRequest.step = step;
    applicationRequest.applicationLogDetailsRequestList = logDetails;

    return this.updateApplicationLogsWithObservable(applicationRequest);
  }

  private allApplicantsInGoodStanding(applicationLogRequest: ApplicationLogsRequest, response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";
    applicationLogRequest.applicants?.forEach(applicant => {
      let eligibilityResponse = response.applicants?.find(appEligibility => appEligibility.applicantId === applicant.applicantId);
      const {isInGoodStanding} = eligibilityResponse!;
      const applicantName = `${applicant.firstName} ${applicant.lastName}`;
      details += `${applicantName} is${!isInGoodStanding ? " not" : ""} in good standing. `;
    })
    return {
      eligible: response.applicants?.every(eligibility => eligibility.isInGoodStanding)!,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    };
  }

  private anyApplicantHasInfoMismatch(applicationLogRequest: ApplicationLogsRequest, response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";
    applicationLogRequest.applicants?.forEach(applicant => {
      let eligibilityResponse = response.applicants?.find(appEligibility => appEligibility.applicantId === applicant.applicantId);
      if (eligibilityResponse!.hasInfoMismatch) {
        details += `Found personal information mismatch for existing customer ${applicant.firstName} ${applicant.lastName}. `
      }
    })
    return {
      eligible: response.applicants?.every(eligibility => !eligibility.hasInfoMismatch)!,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    };
  }

  private anyAccountIsJoint(response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";
    response.applicants?.forEach(applicantSummary => {
      details += `${applicantSummary.anyJointAccount! ? "One of the accounts is joint account" : "None of the accounts are not joint accounts."}`;
    })
    return {
      eligible: response.applicants?.some(applicantSummary => applicantSummary.anyJointAccount) ? false : true,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    }
  }

  private anyWireTransferCountryIsOfacSanctioned(response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";

    response.applicants?.forEach(applicantSummary => {
      details += `${applicantSummary.anyWireTransferCountrySanctioned! ?
        "Wire activity includes the following OFAC sanctioned countries - " + applicantSummary.ofacWireTransferCountries :
        "None of wire activity countries are OFAC sanctioned countries."}`;
    })
    return {
      eligible: response.applicants?.some(applicantSummary => applicantSummary.anyWireTransferCountrySanctioned!) ? false : true,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    }
  }

  private anyApplicantEmployerCountryIsOfacSanctioned(response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";

    response.applicants?.forEach(applicantSummary => {
      details += `${applicantSummary.isEmployerCountrySanctioned! ?
        "One of the Applicant - Employer country is OFAC sanctioned" : "Employer country is not OFAC sanctioned countries."}`;
    })
    return {
      eligible: response.applicants?.some(applicantSummary => applicantSummary.isEmployerCountrySanctioned) ? false : true,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    }
  }

  private verifyAccountAddressStateRule(response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";
    response.products?.forEach(summary => {
      details += `${summary.isEligible! ? 'Primary Applicant address state is not eligible for this product' : ""}`
    })

    return {
      eligible: response.products?.some(applicantSummary => applicantSummary.isEligible)!,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    }
  }

  private anyJointApplicantSSNMatchWithPrimaryApplicantSSN(response: EligibilityResponse): EligibilityCriteriaResult {
    let details = "";

    const hasMatchingInfo = response.applicants?.some(applicantInfo => applicantInfo.hasBothPrimaryAndJointSameSSN);

    if (hasMatchingInfo) {
      details += "Found conflicting SSN between joint applicant and existing account owner."
    }

    return {
      eligible: !hasMatchingInfo,
      log: this.utils.createLog(OnboardingSourceEnum.CORUSCANT, details)
    };
  }

  //get Joint Request Invited by full name
  getInvitedByName(sessionId: string): Observable<string> {
    return this.applicantControllerService.getJointRequestInvitedByName(sessionId);
  }

  /* [BEGIN] KYC Specific Service Methods */
  canUpdateAlloy(applicationLogRequest: ApplicationLogsRequest): boolean {
    if (!this.featureFlags.isFeatureEnabled(Features.AlloyUpdate)) return false;

    if (applicationLogRequest?.status !== StatusEnum.Approved) return true;

    return false;
  }

  async setEvaluateRequestAndExecute(applicantRequest: ApplicantRequest, application: Application, address: any, alloyWorkFlowId: string, alloyMode: string, successCallback: () => void, errorCallback: (message: string) => void) {
    const serviceType: ServiceTypeEnum = alloyMode == AlloyMode.EVAL ? ServiceTypeEnum.AlloyKYC : ServiceTypeEnum.AlloyDocV;

    const evaluateRequest: EvaluateRequest = new EvaluateRequest();
    const {
      firstName,
      middleName,
      lastName,
      suffix,
      ssn,
      phoneNumber,
      dateOfBirth,
      email
    } = applicantRequest;

    const {
      streetAddress,
      streetAddress1,
      zip,
      city,
      state,
      addressType
    } = applicantRequest.addresses?.find(address => address.addressType === AddressType.Physical)!;

    const customerRequest = new GetCustomerRequest();
    customerRequest.ssn = ssn!.replace(/-/gi, "");
    customerRequest.sessionId = "";

    let existingCustomerForAlloy = await firstValueFrom(this.customerControllerService.getExistingCustomerAlloyFlag(customerRequest)).catch(() => {
      return false;
    });

    //Set Address
    let applicantAddress = new ApplicantAddress();
    applicantAddress.streetAddress = streetAddress;
    applicantAddress.streetAddress1 = streetAddress1;
    applicantAddress.city = city;
    applicantAddress.state = this.getState(state);
    applicantAddress.zip = zip;
    applicantAddress.addressType = addressType;
    const applicantAddressList: ApplicantAddress[] = [];
    applicantAddressList.push(applicantAddress);
    applicantRequest.addresses = applicantAddressList;

    evaluateRequest.sessionId = application.sessionId;
    evaluateRequest.nameFirst = firstName;
    evaluateRequest.nameMiddle = getEmptyStringIfNull(middleName);
    evaluateRequest.nameLast = lastName;
    evaluateRequest.nameSuffix = getEmptyStringIfNull(suffix);
    evaluateRequest.phoneNumber = phoneNumber;
    evaluateRequest.documentSSN = ssn;
    evaluateRequest.addressLine1 = streetAddress;
    evaluateRequest.addressLine2 = getEmptyStringIfNull(streetAddress1);
    evaluateRequest.addressCity = city;
    evaluateRequest.addressState = this.getState(state);
    evaluateRequest.addressPostalCode = zip;
    evaluateRequest.birthDate = dateOfBirth;
    evaluateRequest.emailAddress = email;
    evaluateRequest.addressCountryCode = "US";
    evaluateRequest.socialTwitter = "";
    evaluateRequest.existingCustomer = existingCustomerForAlloy;

    evaluateRequest.documentUuid = "";
    evaluateRequest.socureSessionId = "";

    let entityTokenId = "";
    let socureDocumentUuid = "";
    let socureSessionId = "";

    this.leiaApplicantService.getConsumerApplicantIdentityResponseByApplicantId(applicantRequest.applicantId!).subscribe(res => {
      if (alloyMode === AlloyMode.DOCV) {
        if (res.length === 0) {
          this.onError("Push To Alloy Doc V Failed: Applicant Identity Response does not exist.")
          this.setProcessingStatus(false);
          return;
        }

        res.sort((b, a) => a.applicantIdentityResponseId! - b.applicantIdentityResponseId!);

        res.forEach(value => {
          if (socureDocumentUuid.trim() === "" && value.serviceTypeId === ServiceType.Socure && (value.outcome === SocureStatus.SessionComplete || value.outcome === SocureStatus.SessionExpired)) {
            socureDocumentUuid = value.token!;
            socureSessionId = UtilitiesService.deviceRiskSessionId;
          }
          if (entityTokenId.trim() === "" && value.serviceTypeId === ServiceType.AlloyKyc && (value.outcome === AlloyOutcome.Approved || value.outcome === AlloyOutcome.ManualReview || value.outcome === AlloyOutcome.PreviouslyApproved))
            entityTokenId = value.eventId!;
        });

        // Not able to locate Approved or Manual Review Alloy Evaluation - Accept any.
        if (entityTokenId === "") {
          res.forEach(value => {
            if (entityTokenId.trim() === "" && value.serviceTypeId === ServiceType.AlloyKyc && value.eventId !== null) entityTokenId = value.eventId!;
          });
        }

        if (entityTokenId === "") {
          this.onError("Push To Alloy Doc V Failed: Unable to locate previous Entity Token ID.")
          this.setProcessingStatus(false);
          return;
        }
      } else {
        res.forEach(value => {
          if (value.serviceTypeId === ServiceType.AlloyKyc && value.outcome === AlloyOutcome.Approved && value.eventId !== null)
            entityTokenId = value.eventId!;
        });
      }

      evaluateRequest.socureSessionId = socureSessionId;
      evaluateRequest.documentUuid = socureDocumentUuid;

      let applicantIdentityResponseRequest: ApplicantIdentityResponseRequest = new ApplicantIdentityResponseRequest();

      applicantIdentityResponseRequest.applicantId = applicantRequest.applicantId!;
      applicantIdentityResponseRequest.serviceType = serviceType;

      this.leiaApplicantService.startApplicantIdentityResponseSession(applicantIdentityResponseRequest).subscribe(applicantIdentityResponseId => {
        this.executeAlloyEvaluate(evaluateRequest, application, applicantRequest, alloyWorkFlowId, alloyMode, serviceType, entityTokenId, applicantIdentityResponseId, successCallback, errorCallback);
      });
    }, error => {
      if (environment.development) console.warn("Push To Alloy - " + alloyMode + " Failed: " + error);
      this.setProcessingStatus(false);
      this.onError("Push To Alloy " + alloyMode + " Failed: " + error);
    });
  }

  executeAlloyEvaluate(evaluateRequest: EvaluateRequest, application: Application, applicantRequest: ApplicantRequest, alloyWorkflowId: string, alloyMode: string, serviceType: ServiceTypeEnum, entityTokenId: string, applicantIdentityResponseId: number, successCallback: () => void, errorCallback: (message: string) => void) {
    let step = Step.NameEnum.AlloyKyc;
    let stepEnum = OnboardingStepEnum.ALLOYKYC;
    let documentVerify: boolean = false;

    if (alloyMode === AlloyMode.DOCV) {
      step = Step.NameEnum.AlloyDocumentVerification;
      stepEnum = OnboardingStepEnum.ALLOYDOCUMENTVERIFICATION;
      documentVerify = true;
    }

    this.facadeService.executeAlloyEvaluate(evaluateRequest, documentVerify, alloyWorkflowId, entityTokenId).subscribe(salesForceAlloyObject => {
      this.processAlloyResponse(salesForceAlloyObject, "Execute KYC", application, applicantRequest, alloyMode, step, stepEnum, serviceType, applicantIdentityResponseId, successCallback);
    }, error => {
      this.processAlloyError(applicantRequest, error, alloyMode, step, stepEnum, errorCallback);
    });
  }

  updateAlloyResponse(entityTokenId: string, evaluationTokenId: string, applicantRequest: ApplicantRequest, application: Application, applicantIdentityResponseId: number, successCallback: () => void, errorCallback: (message: string) => void) {
    let step = Step.NameEnum.AlloyKyc;
    let stepEnum = OnboardingStepEnum.ALLOYKYC;

    this.kycControllerService.getEntityEvaluations(application.sessionId!, entityTokenId).subscribe(value => {
      this.processAlloyEntityResponse(value, entityTokenId, evaluationTokenId, "Get KYC Entity", application, applicantRequest, step, stepEnum, ServiceTypeEnum.AlloyKYC, applicantIdentityResponseId, successCallback);
    }, error => {
      this.processAlloyError(applicantRequest, error, AlloyMode.EVAL.toString(), step, stepEnum, errorCallback);
    });
  }

  private processAlloyError(applicantRequest: ApplicantRequest, error: any, alloyMode: string, step: Step.NameEnum, stepEnum: OnboardingStepEnum, errorCallback: (message: string) => void) {
    let applicationRequest = this.applicationLogsRequest;

    this.setProcessingStatus(false);
    let logs: Log[] = [];
    let logDetails: ApplicationLogDetailsRequest[] = [];

    logs.push(this.utils.createLog("Coruscant", JSON.stringify(error)));
    logs.push(this.utils.createLog("Coruscant", "User: " + this.getPreferredUsername().toUpperCase() + " , " + ` Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. Alloy ${alloyMode} failed.`));

    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, JSON.stringify(error)));
    logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User: " + this.getPreferredUsername().toUpperCase() + " , " + `Alloy ${alloyMode} failed.`));

    applicationRequest.status = StatusEnum.UnderReview;

    this.updateApplicationWithObservable(step, stepEnum, StateEnum.Fail, OnboardingStateEnum.FAIL, logs, logDetails, applicantRequest.applicantId!, undefined, applicationRequest).subscribe(value => {
      errorCallback("Push To Alloy " + alloyMode + " Failed: " + (error.error?.detail ? error.error.detail : error));
    });
  }

  private processAlloyResponse(salesForceAlloyObject: any, source: string, application: Application, applicantRequest: ApplicantRequest, alloyMode: string, step: Step.NameEnum, stepEnum: OnboardingStepEnum, serviceType: ServiceTypeEnum, applicantIdentityResponseId: number, successCallback: () => void): void {
    const applicationRequest = this.applicationLogsRequest;
    const {sessionId} = application;

    applicationRequest.sessionId = sessionId!;
    applicationRequest.products = application.products;

    if (environment.development) console.warn('salesForceAlloyObject: ' + JSON.stringify(salesForceAlloyObject));

    let log: Log[] = [];
    let logDetails: ApplicationLogDetailsRequest[] = [];
    if (salesForceAlloyObject === undefined || salesForceAlloyObject === null) {
      this.setProcessingStatus(false);

      applicationRequest.status = StatusEnum.UnderReview;
      log.push(this.utils.createLog("Coruscant", "salesForceAlloyObject not returned correctly."));
      log.push(this.utils.createLog("Coruscant", "User: " + this.getPreferredUsername().toUpperCase() + "," + ` Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy ${alloyMode} failed.`));

      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "salesForceAlloyObject not returned correctly."));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User: " + this.getPreferredUsername().toUpperCase() + "," + ` Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy ${alloyMode} failed.`));

      if (alloyMode === AlloyMode.EVAL) {
        application.rcCode = ReferenceCode.AlloyFailure;
        log.push(this.utils.createLog("Coruscant", "Encountered " + application.rcCode));
      }
      if (alloyMode === AlloyMode.DOCV) {
        application.rcCode = ReferenceCode.DocVFailure;
        log.push(this.utils.createLog("Coruscant", "Encountered " + application.rcCode));
      }

      this.updateApplicationWithObservable(step, stepEnum, StateEnum.Fail, OnboardingStateEnum.FAIL, log, logDetails, applicantRequest.applicantId!, application.rcCode!, applicationRequest).subscribe(value => {
        this.onError("Push To Alloy " + alloyMode + " Failed.");
      });

      if (!!application) application.status = StatusEnum.Rejected;
    } else {
      const jsonResponse: string = JSON.stringify(salesForceAlloyObject);

      const {result, outcome, tags} = salesForceAlloyObject.summary!;

      const {entity_token, evaluation_token} = (salesForceAlloyObject as any);

      const isQualifileDeclined = tags?.includes('Qualifile Decline');

      let stepState = StateEnum.Fail;
      let stepStateEnum = OnboardingStateEnum.FAIL;
      if (result === AlloyResult.Success && outcome === AlloyOutcome.Approved) {
        stepState = StateEnum.Success;
        stepStateEnum = OnboardingStateEnum.SUCCESS;
      }

      applicationRequest.applicants?.forEach(applicant => {
        if (applicant.applicantId === applicantRequest.applicantId) {
          applicant.addresses = applicantRequest.addresses;

          if (applicant.applicantIdentityResponses == undefined)
            applicant.applicantIdentityResponses = new Array<ApplicantIdentityResponseRequest>();

          let applicantIdentityResponseRequest: ApplicantIdentityResponseRequest = new ApplicantIdentityResponseRequest();

          applicantIdentityResponseRequest.applicantIdentityResponseId = applicantIdentityResponseId;
          applicantIdentityResponseRequest.applicantId = applicantRequest.applicantId;
          applicantIdentityResponseRequest.outcome = outcome;
          applicantIdentityResponseRequest.token = evaluation_token;
          applicantIdentityResponseRequest.eventId = entity_token;
          applicantIdentityResponseRequest.serviceType = serviceType;

          applicant.applicantIdentityResponses?.push(applicantIdentityResponseRequest);
        }
      });

      if (environment.development) console.warn('jsonResponse: ' + jsonResponse);

      log.push(this.utils.createLog("Coruscant", "User: " + this.getPreferredUsername().toUpperCase() + `, Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy ${alloyMode} Complete. Response: ${jsonResponse}.`));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User: " + this.getPreferredUsername().toUpperCase() + ", " + `Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL} Source: ${source}. Alloy ${alloyMode} Complete. Response: ${jsonResponse}.`));

      applicationRequest.status = StatusEnum.UnderReview;

      if (stepState === StateEnum.Fail) {
        if (alloyMode === AlloyMode.EVAL && outcome === AlloyOutcome.Denied) {
          applicationRequest.status = StatusEnum.Rejected;
          applicationRequest.rcCode = isQualifileDeclined ? ReferenceCode.AlloyQualifileDecline : ReferenceCode.AlloyDenied;
          log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
          logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
        }
        if (alloyMode === AlloyMode.EVAL && outcome === AlloyOutcome.ManualReview) {
          applicationRequest.rcCode = ReferenceCode.AlloyUnderReview;
          log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
          logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
        }

        if (alloyMode === AlloyMode.DOCV && outcome === AlloyOutcome.Denied) {
          applicationRequest.status = StatusEnum.Rejected;
          applicationRequest.rcCode = ReferenceCode.DocVDenied;
          log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
          logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
        }
        if (alloyMode === AlloyMode.DOCV && outcome === AlloyOutcome.ManualReview) {
          applicationRequest.rcCode = ReferenceCode.DocVUnderReview;
          log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
          logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
        }
      }

      this.updateApplicationWithObservable(step, stepEnum, stepState, stepStateEnum, log, logDetails, applicantRequest.applicantId!, applicationRequest.rcCode!, applicationRequest).subscribe(value => {
        successCallback();
      });
    }
  }

  private processAlloyEntityResponse(alloyEntityEvaluationResponseList: AlloyEntityEvaluationResponse[], entityTokenId: string, evaluationTokenTemp: string, source: string, application: Application, applicantRequest: ApplicantRequest, step: Step.NameEnum, stepEnum: OnboardingStepEnum, serviceType: ServiceTypeEnum, applicantIdentityResponseId: number, successCallback: () => void) {
    const applicationRequest = this.applicationLogsRequest;
    const {sessionId, clientIpAddress} = application;

    applicationRequest.sessionId = sessionId!;
    applicationRequest.clientIpAddress = clientIpAddress;
    applicationRequest.products = application.products;

    if (environment.development) console.warn('alloyEntityEvaluationResponseList: ' + JSON.stringify(alloyEntityEvaluationResponseList));

    let log: Log[] = [];
    let logDetails: ApplicationLogDetailsRequest[] = [];
    if (alloyEntityEvaluationResponseList === undefined) {
      this.setProcessingStatus(false);

      applicationRequest.status = StatusEnum.UnderReview;
      log.push(this.utils.createLog("Coruscant", "alloyEntityResponse not returned correctly."));
      log.push(this.utils.createLog("Coruscant", "User: " + this.getPreferredUsername().toUpperCase() + "," + ` Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy Get Entity failed.`));

      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "alloyEntityResponse not returned correctly."));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User: " + this.getPreferredUsername().toUpperCase() + "," + ` Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy Get Entity failed.`));

      applicationRequest.rcCode = ReferenceCode.AlloyFailure;

      log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
      logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));

      this.updateApplicationWithObservable(step, stepEnum, StateEnum.Fail, OnboardingStateEnum.FAIL, log, logDetails, applicantRequest.applicantId, applicationRequest.rcCode, applicationRequest).subscribe(value => {
        this.onError("Push To Alloy - Get Entity Failed.");
      });

      if (!!application) application.status = StatusEnum.Rejected;
    } else {
      const jsonResponse: string = JSON.stringify(alloyEntityEvaluationResponseList);

      let outcomeTemp: any = undefined;

      alloyEntityEvaluationResponseList.forEach(alloyEntityEvaluationResponse => {
        const {outcome, evaluationToken} = alloyEntityEvaluationResponse;

        if (evaluationTokenTemp === evaluationToken && outcomeTemp === undefined) {
          outcomeTemp = outcome;

          applicationRequest.applicants?.forEach(applicant => {
            if (applicant.applicantId === applicantRequest.applicantId) {

              if (applicant.applicantIdentityResponses == undefined)
                applicant.applicantIdentityResponses = new Array<ApplicantIdentityResponseRequest>();

              let applicantIdentityResponseRequest: ApplicantIdentityResponseRequest = new ApplicantIdentityResponseRequest();

              applicantIdentityResponseRequest.applicantIdentityResponseId = applicantIdentityResponseId;
              applicantIdentityResponseRequest.applicantId = applicantRequest.applicantId;
              applicantIdentityResponseRequest.outcome = outcome;
              applicantIdentityResponseRequest.token = evaluationToken;
              applicantIdentityResponseRequest.eventId = entityTokenId;
              applicantIdentityResponseRequest.serviceType = serviceType;

              applicant.applicantIdentityResponses?.push(applicantIdentityResponseRequest);
            }
          });
        }
      });

      if (outcomeTemp != undefined) {
        let stepState = StateEnum.Fail;
        let stepStateEnum = OnboardingStateEnum.FAIL;
        if (outcomeTemp === AlloyOutcome.Approved) {
          stepState = StateEnum.Success;
          stepStateEnum = OnboardingStateEnum.SUCCESS;
        }
        if (environment.development) console.warn('jsonResponse: ' + jsonResponse);

        log.push(this.utils.createLog("Coruscant", "User: " + this.getPreferredUsername().toUpperCase() + `, Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL}. Source: ${source}. Alloy Get Entity Complete. Response: ${jsonResponse}.`));
        logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "User: " + this.getPreferredUsername().toUpperCase() + ", " + `Applicant: ${applicantRequest.firstName} ${applicantRequest.lastName}. ApplicantType: ${!applicantRequest.primary ? SECONDARY_APPLICANT_LABEL : PRIMARY_APPLICANT_LABEL} Source: ${source}. Alloy Get Entity Complete. Response: ${jsonResponse}.`));

        applicationRequest.status = StatusEnum.UnderReview;

        if (stepState === StateEnum.Fail) {
          if (outcomeTemp === AlloyOutcome.Denied) {
            applicationRequest.status = StatusEnum.Rejected;
            applicationRequest.rcCode = ReferenceCode.AlloyDenied;

            log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
            logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
          }
          if (outcomeTemp === AlloyOutcome.ManualReview) {
            applicationRequest.rcCode = ReferenceCode.AlloyUnderReview;

            log.push(this.utils.createLog("Coruscant", "Encountered " + applicationRequest.rcCode));
            logDetails.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.CORUSCANT, "Encountered " + applicationRequest.rcCode));
          }
        }
        this.updateApplicationWithObservable(step, stepEnum, stepState, stepStateEnum, log, logDetails, applicantRequest.applicantId, applicationRequest.rcCode, applicationRequest).subscribe(value => {
          successCallback();
        });
      } else successCallback();
    }
  }

  /* [END] KYC Specific Service Methods */
}
